import ReactDOM from 'react-dom';
import { GENERATE_PDF_URL } from './config';
import { getHeaders } from './fetch';

export async function generatePDF(reference) {
  const node = ReactDOM.findDOMNode(reference);
  const nodeHtml = node.outerHTML;

  const styles = document.querySelectorAll('style[data-jss]');

  const html = [
    '<html>',
    '<head>',
    '<style>body { margin: 30px; } * { font-family: Arial; }</style>',
    ...Array.from(styles)
      .map(style => style.outerHTML),
    '</head>',
    '<body>',
    nodeHtml,
    '</body>',
    '</html>'
  ].join('');

  const response = await fetch(
    GENERATE_PDF_URL,
    {
      method: 'POST',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        html
      })
    }
  );

  const { url } = await response.json();

  const pdfResponse = await fetch(url);
  const pdfBlob = await pdfResponse.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader;
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(pdfBlob);
  });
}

export function downloadPDF(base64PDFUri, name = `rewards-report-${Date.now()}.pdf`) {
  const a = document.createElement('a');
  a.href = base64PDFUri;
  a.download = name;
  a.target = '_blank';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}


// WEBPACK FOOTER //
// ./src/services/pdf.js